import React, { useEffect, useState } from "react";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import auth from '../../../service/Auth';

const SelectOwner =(props)=> {
    return (
        <Select
            labelId="select-owner"
            id="id-select-owner"
            value={props.owner}
            label="Group Owner"
            onChange={props.selectOwner}
            sx={{ maxHeight: 40 }}
        >
            { props.groups.map(group => { return <MenuItem value={group} key={group}>{group}</MenuItem> })}
        </Select>
    );
}

const SelectNeutral =(props)=> {
    return (
        <FormControl sx={{ m: 2, minWidth: 150}}>  
            <InputLabel id="select-label">Group Owner</InputLabel>              
            <SelectOwner owner={props.owner} selectOwner={props.selectOwner} groups={props.groups}/>
        </FormControl>
    );
}

const SelectError =(props)=> {
    return (
        <FormControl sx={{ m: 2, minWidth: 150 }} error>   
            <InputLabel id="select-label">Group Owner</InputLabel>              
            <SelectOwner owner={props.owner} selectOwner={props.selectOwner} groups={props.groups}/>
            <FormHelperText>{props.error}</FormHelperText>
        </FormControl>
    );
}

/* Select Owner according to errors*/
const OwnerSelector =(props) =>{
    
    const [groups, setGroups] = useState(["----"]);
    const [error, setError] = useState("Please, select a group owner.");
    
    const getUserGroups = () => {
        return auth.getUser().keycloak.idTokenParsed.group.map(basename);
    }

    const selectOwner = (event) => {
        props.setOwner(event.target.value);
        if (validate(event.target.value)) {
            props.setValid(true)
        } else {
            props.setValid(false);
        }
    }

    useEffect(() => {  
        let userGroups = getUserGroups();
        userGroups.unshift("----");
        setGroups(userGroups);
        if(props.error !== undefined ) {
            if (props.error !== "") {
                setError(props.error);
                props.setValid(false);
            } 
        }
    },[]);

    useEffect(() => {
        if(props.error !== undefined ) {
            if (props.error !== "") {
                setError(props.error);
                props.setValid(false);
            } 
        }
    }, [props.error]);

    useEffect(() => {
        if (props.owner != "----") {
            if (props.error !== undefined) {
                setError(props.error);
                props.setValid(true);
            }
        }
    }, [props.owner]); 

    const basename = path => { return path.replace(/.*\//, '');}

    const validate = (selected) => {
        let userGroups = getUserGroups();
        if  (!userGroups.includes(selected)) {
            setError("Sorry! No valid group choice selected!")
            return false;
        }
        setError("");
        return true;
    }

    if (error !== "") {
        return(
            <SelectError error={error} owner={props.owner} selectOwner={selectOwner} groups={groups}/>
        );
    } else {
        return(
            <SelectNeutral owner={props.owner} selectOwner={selectOwner} groups={groups}/>
        );
    }
}

export default OwnerSelector;
